import {
  HiddenFeature as hiddenReducer,
  HiddenPayload,
  setHiddenAction,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../../Types';
import { dummyDispatch } from '../ParamFromSchema';

export const reduceHidden =
  (payload: HiddenPayload) => (state: BridgeFormJSState) =>
    hiddenReducer(state, setHiddenAction(dummyDispatch)(payload));
